import React from 'react'
import { useEffect } from 'react';
import WelcomeSection from '../Components/Pages/WelcomeSection';
import PlansSection from '../Components/Pages/PlansSection';
import PricingSection from '../Components/Pages/PricingSection';
import ContactSection from '../Components/Pages/ContactSection';
import FunctionnalitySection from '../Components/Pages/FunctionnalitySection';
import TemplatesSection from '../Components/Pages/TemplatesSection';
import Footer from '../Components/Footer/Footer';
import { Helmet } from 'react-helmet-async';
import './WebsiteTheme.css';
import './WebsiteAnimations.css';


const Main = () => {
  useEffect(() => {
    const site = document.querySelector('.wb-site');
    if (!site) return undefined;
    const targets = site.querySelectorAll(
      '.wb-command-intro, .wb-command-card, .wb-protocol-heading, .wb-protocol-step, .wb-protocol-link, .wb-opportunity-header, .wb-opportunity-card, .wb-contact-intel, .wb-contact-panel, .wb-footer-brand, .wb-footer-column'
    );
    targets.forEach((element, index) => {
      element.classList.add('wb-reveal');
      element.style.setProperty('--wb-reveal-delay', `${(index % 6) * 70}ms`);
    });
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('wb-reveal-visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    targets.forEach((element) => observer.observe(element));
    const updatePointer = (event) => {
      site.style.setProperty('--wb-pointer-x', `${event.clientX}px`);
      site.style.setProperty('--wb-pointer-y', `${event.clientY}px`);
    };
    window.addEventListener('pointermove', updatePointer, { passive: true });
    return () => {
      observer.disconnect();
      window.removeEventListener('pointermove', updatePointer);
    };
  }, []);

  return (
    <>
      <Helmet>

        <title>
          CarrerUp — La Plateforme Sport-Tech pour Athlètes, Clubs & Agents
        </title>

        <meta
          name="description"
          content="CarrerUp connecte athlètes, clubs, agents sportifs, sponsors et médias dans un seul écosystème digital. Rejoignez la révolution du sport professionnel."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "CarrerUp",
            url: "https://carrerup.com",
            logo: "https://carrerup.com/logo.png",
            description:
              "Sport-Tech platform connecting athletes, clubs, agents, sponsors and media.",
            sameAs: []
          })}
        </script>

        <meta property="og:type" content="website" />

        <meta property="og:site_name" content="CarrerUp" />

        <meta
          property="og:title"
          content="CarrerUp — La Plateforme Sport-Tech pour Athlètes, Clubs & Agents"
        />

        <meta
          property="og:description"
          content="CarrerUp connecte athlètes, clubs, agents sportifs, sponsors et médias."
        />

        <meta
          property="og:url"
          content="https://carrerup.com"
        />

        <meta
          property="og:image"
          content="https://carrerup.com/og-image.jpg"
        />

      </Helmet>

      <div className="wb-site">
        <WelcomeSection />
        <FunctionnalitySection />
        <TemplatesSection />
        <PlansSection />
        <PricingSection />
        <ContactSection />
        <Footer />
      </div>
    </>
  )
}

export default Main
